import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getDeadlinesGroupingByScope } from "../../store/actions/deadlines/company";
import { Button } from "@ts-digital/vrc";
import { deadlineTypes } from "../../constants/scadenze";
import noDeadlinesImg from "../../assets/img/nessuna-scadenza.svg";
import WidgetCard from "../widget/card";
import "./style.css";

const WidgetCommercialista = props => {
  const {
    accountantSelected,
    accountantIdSelected,
    goToOtherDeadlinesSubjective,
    isDoubleBox,
    numberItems
  } = props;
  // TODO: andare a raggruppare per scope e non per type e poi filtrare per fiscal_social_security
  //   const [selectedTaxRegime, setSelectedTaxRegime] = useState(null);
  const dispatch = useDispatch();
  const customersText = useIntl().formatMessage({ id: "deadlines.widget.customers"});
  const customerText = useIntl().formatMessage({ id: "deadlines.widget.customer" });

  const isGettingDeadlinesGroupingByScope = useSelector(state => state.deadlinesCompany.isGettingDeadlinesGroupingByScope);
  const subjective = useSelector(state => state.deadlinesCompany.subjective);

  useEffect(() => {
    dispatch(getDeadlinesGroupingByScope(numberItems,
      "fiscal_social_security"));
  }, [accountantSelected, accountantIdSelected, numberItems]);

  const formatDate = data => {
    let dateFormatted = moment(data).format(DATE_FORMAT_FOR_DISPLAY);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (dateFormatted === moment(today).format(DATE_FORMAT_FOR_DISPLAY))
      dateFormatted = <FormattedMessage id="generic.today" />;
    if (dateFormatted === moment(tomorrow).format(DATE_FORMAT_FOR_DISPLAY))
      dateFormatted = <FormattedMessage id="generic.tomorrow" />;

    return dateFormatted;
  };

  const renderContentDeadlines = () => {
    let arrayFirstCol = [];
    let arraySecondCol = []; // questa è valorizzata solo nel caso di box doppio = isDoubleBox a true
    if (
      (!subjective || subjective.length === 0) &&
      !isGettingDeadlinesGroupingByScope
    )
      arrayFirstCol.push(<div key="noDeadlines" style={{textAlign: "center"}} >
        <img src={noDeadlinesImg} alt=""/>
        <div
          style={{
            fontSize: 20,
            color: "#152935",
            marginTop: 40,
            fontWeight: "normal",
            textAlign: "center",
            letterSpacing: "0px",
            lineHeight: "32px",
            width: "60%",
            display: "inline-grid"
          }}
        >
          <FormattedMessage id="deadlines.widget.noDeadlinesAccountant" />
        </div>
      </div>);
    else {
      /** ciclo la lista delle deadlines nello stato redux per il numero di items richiesto dal parent */
      for (let count = 0; count < numberItems; count++) {
        /** TODO separare in da pagare e da Incassare. Secondo ux se non ci sono da Incassare resta tutto
         * da pagare. Tenere in considerazione questo. Si potrebbero fare 2 chiamate in componentDidMount
         * uno per i da pagare e uno da Incassare e poi unire in subjective tramite reducer.
         * Per ora chiamo la solita lista
         * se doubleBox è true allora divido su 2 colonne e popolo prima arrayFirstCol e dopo arraySecondCol
         * altrimenti solo arrayFirstCol
         */
        let currentSubjective = subjective[count];

        /** potrei avere il caso che chiedo es 8 elementi e me ne ritornano 4 perchè a db non abbiamo
         * 8 scadenze la if gestisce il caso, senza andrebbe in errore
         * */
        if (currentSubjective) {
          let renderRow = renderRowDeadline(
            currentSubjective.type,
            currentSubjective.count,
            currentSubjective.date
          );
          if (isDoubleBox && count >= numberItems / 2) {
            arraySecondCol.push(renderRow);
          } else {
            arrayFirstCol.push(renderRow);
          }
        }
      }
    }

    return (
      <div className="containerFlex">
        <div
          className={isDoubleBox ? "columnFlex50 withMargin" : "columnFlex100"}
        >
          {arrayFirstCol}
        </div>
        {isDoubleBox ? (
          <div className="columnFlex50">{arraySecondCol}</div>
        ) : null}
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div style={{ textAlign: isDoubleBox ? "right" : "center" }}>
        <div>
          <Button
            kind={"secondary"}
            onClick={e => goToOtherDeadlinesSubjective()}
            colorScheme={"ghost"}
          >
            <FormattedMessage id="deadlines.widget.showAll" />
          </Button>
        </div>
      </div>
    );
  };

  const renderRowDeadline = (
    type, count, data
  ) => {
    let dateFormatted = "";
    let typeDecoded = type;
    if (data && data.trim().length > 0) {
      dateFormatted = formatDate(data);
    }
    deadlineTypes?.map(deadline => {
      if (deadline.key === type) {
        typeDecoded = deadline.desc;
      }
      return typeDecoded;
    });

    return (
      <div
        key={"rowDeadline_" + dateFormatted + typeDecoded + count}
        className="containerFlex"
        style={{
          padding: "16px",
          borderBottom: "1px solid #eaeaf5",
          borderTop: "1px solid #eaeaf5"
        }}
      >
        <div className="columnFlex40 blueData" style={{ padding: "0 8px" }}>
          <b>{dateFormatted}</b>
        </div>
        <div className="columnFlex60" style={{ paddingRight: "16px" }}>
          <div className="textTruncate">
            <b>{typeDecoded}</b>
            <br />
            <span style={{ color: "#5a6872" }}>
              {count}{" "}
              {count > 1 ? customersText : customerText}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderTitle = () => {
    const notEmptyDeadlines = subjective && subjective.length > 0;
    return (
      <div
        style={{
          width: "100%",
          display: "inline-block",
          marginTop: 13,
          alignItems: "center",
          borderBottom: notEmptyDeadlines ? "none" : "1px solid #f2f5f8",
          paddingBottom: notEmptyDeadlines ? "initial" : 8
        }}
      >
        <FormattedMessage id="deadlines.widgetAccountantTitle" />
      </div>
    );
  };

  return (
    <WidgetCard
      type={
        isDoubleBox && !isGettingDeadlinesGroupingByScope // || (!isGettingDeadlinesGroupingByScope && subjective && subjective.length > 0 && subjective.length < numberItems / 2 + 1)
          ? "box2_3"
          : "box1_3"
      }
      titleWidget={renderTitle()}
      footer={renderFooter()}
      isCentered={!subjective ||
        isGettingDeadlinesGroupingByScope ||
        (subjective && subjective.length === 0)
      }
    >
      {!isGettingDeadlinesGroupingByScope ? (
        renderContentDeadlines()
      ) : (
        <FontAwesomeIcon
          icon={["far", "circle-notch"]}
          spin
          style={{ color: "#0090d1" }}
        />
      )}
    </WidgetCard>
  );
};

export default WidgetCommercialista;
